const substituteEncodedCharacters = require('./substituteEncodedCharacters')
const _get = require('lodash.get')

function HTMLconverter (data, scriptTitle, opts) {
  const print = _get(opts, 'print', false)
  const numbering = _get(opts, 'numbering', false)

  const titlePage = []
  const titleInfo = []
  const html = []
  let title
  let dialogue = data.filter(token => (token.type === 'character' && !token.break)).length
  let scenes = data.filter(token => token.type === 'scene_heading').length

  for (let i = data.length - 1; i > -1; i--) {
    const token = data[i]
    // TODO: figure out a better way of dealing with empty text; possibly
    // throwing in a few asserts in this package
    // Sometimes token.text is undefined, and we need to explicitely set it to
    // an empty space for rendering html
    if (token.text === '') {
      token.text = ' '
    }
    if (!token.wrapped) {
      token.wrapped = token.text
    }
    token.html = substituteEncodedCharacters(token.wrapped, 'STRUCTURE_TO_HTML')
    token.text = substituteEncodedCharacters(token.text, 'STRUCTURE_TO_HTML')

    const text = print ? token.html : token.text

    switch (token.type) {
      case 'title':
        titleInfo.push(`<p class="title">${token.text}</p>`)
        if (title) {
          title = token.text.replace('<br />', ' ').replace(/<(?:.|\n)*?>/g, '')
        }
        break
      case 'credit':
        titleInfo.push(`<p class="credit">${text}</p>`)
        break
      case 'author':
        titleInfo.push(`<p class="authors">${text}</p>`)
        break
      case 'authors':
        titleInfo.push(`<p class="authors">${text}</p>`)
        break
      case 'source':
        titleInfo.push(`<p class="source">${text}</p>`)
        break
      case 'notes':
        titlePage.push(`<p class="notes">${text}</p>`)
        break
      case 'draft_date':
        titlePage.push(`<p class="draft_date">${text}</p>`)
        break
      case 'date':
        titlePage.push(`<p class="date">${text}</p>`)
        break
      case 'contact':
        titlePage.push(`<p class="contact">${text}</p>`)
        break
      case 'copyright':
        titlePage.push(`<p class="copyright">${text}</p>`)
        break
      case 'title_page_break':
        if (print) html.push(`<div class="page-header" data-page-number=${token.logical_page}.>${scriptTitle}</div>`)
        html.push('<div class="page-wrapper">')
        titlePage.unshift(`<hr class="page-break" data-page-number=${token.logical_page}. />`)
        break

      case 'scene_heading': {
        const sceneNumber = numbering ? 'scene-number' : ''
        html.push(`<p class="scene_heading ${sceneNumber}" data-number="${scenes}">${text}</p>`)
        scenes--
        break
      }
      case 'transition':
        html.push(`<p class="transition">${text}</p>`)
        break

      case 'dual_dialogue_begin':
        html.push('<div class="dual-container">')
        break
      case 'dialogue_begin':
        html.push(`<div class="dialogue ${token.dual ? token.dual : ''}">`)
        break
      case 'character': {
        const brokenClass = token.break ? 'character-broken' : 'character'
        const speechNumber = numbering && !token.break ? 'speech-number' : '' // comes from url params which are strings :/
        html.push(`<p class="${brokenClass} ${speechNumber}" data-number="${dialogue}">${text}</p>`)
        if (!token.break) dialogue--
        break
      }
      case 'parenthetical':
        html.push(`<p class="parenthetical">${text}</p>`)
        break
      case 'dialogue':
        html.push(`<p>${text}</p>`)
        break
      case 'dialogue_end':
        html.push('</div>')
        break
      case 'dual_dialogue_end':
        html.push('</div>')
        break
      case 'lyrics':
        html.push(`<p class="lyrics">${text}</p>`)
        break
      case 'section':
        html.push(`<p class="section" data-depth="${token.depth}">${text}</p>`)
        break
      case 'synopsis':
        html.push(`<p class="synopsis">${text}</p>`)
        break

      case 'note':
        html.push(`<!-- ${text} -->`)
        break
      case 'boneyard_begin':
        html.push('<!-- ')
        break
      case 'boneyard_end':
        html.push(' -->')
        break

      case 'action':
        html.push(`<p>${text}</p>`)
        break
      case 'centered':
        html.push(`<p class="centered" style="text-align: center;">${text}</p>`)
        break

      case 'page_break':
        html.push('<div class="page-wrapper">')
        if (print) html.push(`<div class="page-header" data-page-number=${token.logical_page}.>${scriptTitle}</div>`)
        html.push(`<hr class="page-break" data-page-number=${token.logical_page}. />`)
        break
      case 'page_end':
        html.push('<!-- page_end --></div>')
        break
      case 'line_break':
        html.push('<br />')
        break
    }
  }

  const titlePresent = titlePage.length !== 0 || titleInfo.length !== 0
  const titlePageContent = titlePresent ? `<div class="titlePage"><div class="titleInfo">${titleInfo.reverse().join('')}</div>${titlePage.reverse().join('')}</div>` : ''

  if (!titlePresent) {
    html.push('<div class="page-wrapper">')
    if (print) html.push(`<div class="page-header" data-page-number="1.">${scriptTitle}</div>`)
    else html.push('<hr class="page-num" data-page-number="1." />')
  }

  // The last page doesn't have a page_end element so add one to balance the divs
  html.unshift('<!-- last page_end --></div>')

  const script = html.reverse().join('')
  const result = {
    title,
    html: {
      title_page: titlePageContent,
      script
    }
  }

  return result
}

module.exports = HTMLconverter
